module.exports = __webpack_public_path__ + "static/media/Node.533e7cc1.jpg";